import { configureStore, combineReducers } from "@reduxjs/toolkit";
import bookingValidationReducer from "./booking-validation";
import allSupplementDetails from "./supplement-details";
import allCabinDetails from "./cabin-upgrade";
import cartReducer from "./cart-items";
import finalChecklnProcess from "./final-checkln-process";

// Load state from session storage
export const loadState = () => {
  try {
    const serializedState = sessionStorage.getItem("reduxState");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

// Save state to session storage
export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    sessionStorage.setItem("reduxState", serializedState);
  } catch (err) {
    // Ignore write errors
  }
};

// Clear session storage after a specific time
export const clearTime = 3600000; // 60 mins

export function clearSessionStorage() {
  sessionStorage.removeItem("reduxState");
  console.log("Session storage cleared");
}

// Combine all reducers
const appReducer = combineReducers({
  bookingValidation: bookingValidationReducer,
  allSupplementDetails: allSupplementDetails,
  allCabinDetails: allCabinDetails,
  cart: cartReducer,
  finalChecklnProcess: finalChecklnProcess,
});

// Root reducer that handles the LOGOUT action
const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    state = undefined; // Reset the state to undefined, which will reset all slices
    clearSessionStorage(); // Clear session storage on logout
  }
  return appReducer(state, action);
};

const persistedState = loadState();

const store = configureStore({
  reducer: rootReducer, // Use the rootReducer
  preloadedState: persistedState,
});

setTimeout(() => {
  store.dispatch({ type: "LOGOUT" });
  alert("Session expired. Please login again.");
}, clearTime);

// Save the state to session storage whenever it changes
store.subscribe(() => {
  saveState(store.getState());
});

// Function to handle logout
export const handleLogout_store = () => {
  store.dispatch({ type: "LOGOUT" });
};

export default store;
